<p>super-class works!</p>
